<div class="privacy">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h4>Privacy check</h4>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <ul>
          <li *ngIf="borrower?.person">{{borrower?.person?.firstName}} {{borrower?.person?.lastName}}</li>
          <li *ngIf="borrower?.company">{{borrower?.company?.companyName}}</li>
          <li *ngIf="borrower?.person">{{borrower?.person?.dateOfBirth | date}}</li>
          <li *ngFor="let email of borrower?.emailAddressList">{{email.EmailAddress.emailAddress}}</li>
          <li *ngFor="let phone of borrower?.phoneList">
            <span *ngIf="phone.TelephoneTypeID === 1">Fixed</span>
            <span *ngIf="phone.TelephoneTypeID === 2">Fax</span>
            <span *ngIf="phone.TelephoneTypeID === 3">Mobile</span>
            {{phone.TelephoneNumber.telephoneNumber}}
          </li>
          <li *ngFor="let address of borrower?.addressList">{{address.Address.addressText}}</li>
        </ul>
      </div>
    </div>
    <div class="row mb-2" *ngIf="!privacyVerified">
      <div class="col-12">
        <button mat-raised-button color="error" class="me-4" (click)="verifyPrivacy(false)">Incomplete</button>
        <button mat-raised-button color="primary" (click)="verifyPrivacy(true)">Complete</button>
      </div>
    </div>
  </div>
</div>
